import { PATH_NAME } from 'configs';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import DynamicTable from 'utils/DynamicTable';
import { GuidelineTableHeaders, complaintsTableHeaders } from 'utils/TableHeaderUtils';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';

export const modifiedGuidelineData = [
  {
    _id: '1',
    category: 'Built Environment',
    subCategory: 'Banks',
  },
  {
    _id: '2',
    category: 'Built Environment',
    subCategory: 'Courts',
  },
  {
    _id: '3',
    category: 'Built Environment',
    subCategory: 'Cultural Centers',
  },
  {
    _id: '4',
    category: 'Built Environment',
    subCategory: 'Government Building',
  },
  {
    _id: '5',
    category: 'Built Environment',
    subCategory: 'Hospitals/Clinics',
  },
  {
    _id: '6',
    category: 'Built Environment',
    subCategory: 'Hotels',
  },
  {
    _id: '7',
    category: 'Built Environment',
    subCategory: 'Monument Complex',
  },
  {
    _id: '8',
    category: 'Built Environment',
    subCategory: 'Parks',
  },
  {
    _id: '9',
    category: 'Built Environment',
    subCategory: 'Police Station',
  },
  {
    _id: '10',
    category: 'Built Environment',
    subCategory: 'Schools',
  },
];

const GuidelineCircularsView = () => {
  const [data, setData] = useState([]);
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const totalComplaints = 10;

  const handleEdit = (id: string) => {
    // Handle edit action
    history.push(`${PATH_NAME.GUIDELINES_AND_CIRCULARS_EDIT}/${id}`);

    console.log('Edit:', id);
  };

  const handleDelete = (id: string) => {
    // Handle delete action
    console.log('Delete:', id);
  };

  return (
    <div>
      <Grid container style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Guidelines and Circulars</h1>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => history.push(PATH_NAME.GUIDELINES_AND_CIRCULARS_ADD)}
        >
          Add New
        </Button>
      </Grid>

      <DynamicTable
        headers={GuidelineTableHeaders}
        rows={modifiedGuidelineData}
        onEdit={handleEdit}
        setCurrentPage={setCurrentPage}
        noOfPages={totalComplaints}
      />
    </div>
  );
};

export default GuidelineCircularsView;
